import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import HandleTaskActionModalContainer from './HandleTaskActionModalContainer';
import {setProductHandleTaskModal} from '../../../../store/slice/PharmaSlice';
import { setSelectedTaskObj } from 'store/slice/AppSlice';
import ShowProductProgress from 'components/wkf/page/ShowProductProgress';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function HandleTaskActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [showProgress, setShowProgress] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {HandleTaskModalOpen, productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
  const {selectedTaskObj} = useSelector((state) => state.appslice.wkflow);

  useEffect(()=>{
  },[HandleTaskModalOpen, selectedTaskObj])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setProductHandleTaskModal(false));
    dispatch(setSelectedTaskObj({}));
    setShowProgress(false); // Reset view when modal closes
  }

  const handleShowProgress = () => {
    setShowProgress(true);
  }

  const handleShowTask = () => {
    setShowProgress(false);
  }

  return (
    <Modal
       open={HandleTaskModalOpen===undefined?false:HandleTaskModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              {selectedTaskObj.title!==undefined?selectedTaskObj.title:"-"} @ {productObj && productObj.brandname}
            </Typography>
          </Grid>
          <Grid item>
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item>
                {!showProgress ? (
                  <Button 
                    variant="outlined" 
                    onClick={handleShowProgress}
                    sx={{
                      borderColor: 'primary.main',
                      color: 'primary.main',
                      '&:hover': {
                        backgroundColor: 'primary.main',
                        color: 'white'
                      }
                    }}
                  >
                    Show Progress
                  </Button>
                ) : (
                  <Button 
                    variant="outlined" 
                    onClick={handleShowTask}
                    sx={{
                      borderColor: 'secondary.main',
                      color: 'secondary.main',
                      '&:hover': {
                        backgroundColor: 'secondary.main',
                        color: 'white'
                      }
                    }}
                  >
                    Show Task
                  </Button>
                )}
              </Grid>
              <Grid item>
                <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
          {showProgress ? (
            <ShowProductProgress />
          ) : (
            <HandleTaskActionModalContainer />
          )}
        </Grid>

      </Box>
    </Modal>
  );
}